<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-data-iterator
      v-model="selected"
      :items="invoices"
      item-key="id"
      :options.sync="$store.state.optionsList"
      :search="$store.state.searchList"
      :footer-props="footerOptions"
      :hide-default-footer="$mobileDetect.phone() !== null"
      :no-results-text="$t('home.noInvoices')"
      style="width: inherit"
    >
      <template v-slot:default="{items, isSelected, select}">
        <v-row>
          <v-col
            v-for="item in items"
            :key="item.id"
            md="3"
            cols="12"
          >
            <v-card class="card-grid">
              <v-card-title>
                <v-checkbox
                  v-if="!$mobileDetect.phone() && !$mobileDetect.tablet()"
                  class="ma-0"
                  :input-value="isSelected(item)"
                  primary
                  hide-details
                  @change="(v) => select(item, v)"
                >
                  <template v-slot:label>
                    <v-badge
                      color="primary"
                      :value="false"
                    >
                      <template v-slot:badge>
                        <span>!</span>
                      </template>
                      <h4 class="mr-1">
                        {{ item.viewDate | toLocaleDate($i18n.locale) }}
                        <v-chip
                          color="primary"
                          style="color: white"
                          small
                          disabled
                        >
                          {{ item.customer.id }}
                        </v-chip>
                      </h4>
                    </v-badge>
                  </template>
                </v-checkbox>
                <v-badge
                  v-else
                  color="primary"
                  :value="false"
                  class="v-label"
                >
                  <template v-slot:badge>
                    <span>!</span>
                  </template>
                  <h4 class="mr-1">
                    {{ item.viewDate | toLocaleDate($i18n.locale) }}
                    <v-chip
                      color="primary"
                      style="color: white"
                      small
                      disabled
                    >
                      {{ item.customer.id }}
                    </v-chip>
                  </h4>
                </v-badge>
                <v-spacer />
                <v-btn
                  v-if="!$mobileDetect.phone() && !$mobileDetect.tablet()"
                  icon
                  color="transparent"
                  @click="$store.dispatch('showInvoice', item.id)"
                >
                  <v-icon color="primary">
                    far fa-eye
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="transparent"
                  @click="$store.dispatch('downloadInvoices', [item.id])"
                >
                  <v-icon color="primary">
                    far fa-arrow-alt-circle-down
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-divider class="custom-divider primary--text" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template v-slot:no-data>
        {{ $t('home.noInvoices') }}
      </template>
    </v-data-iterator>
  </v-container>
</template>
<script>
  export default {
    name: 'GridView',
    filters: {
      toLocaleDate (value, locale) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        const date = new Date(value)
        return date.toLocaleDateString(locale, options)
      },
    },
    data () {
      return {
        footerOptions: {
          itemsPerPageOptions: [3, 6, 9, 12, -1],
          itemsPerPageAllText: this.$t('home.all'),
          itemsPerPageText: this.$t('home.itemsPerPage'),
        },
      }
    },
    computed: {
      selected: {
        get () {
          return this.$store.state.invoices.selected
        },
        set (value) {
          this.$store.commit('SET_SELECTED_INVOICES', value)
        },
      },
      invoices () {
        return this.$store.state.invoices.filtered
      },
    },
    created () {
      if (this.$mobileDetect.phone()) {
        this.contentClass += ' scroll-area-mobile'
      } else {
        this.contentClass += ' scroll-area-desktop'
      }
    },
  }
</script>

<style scoped>
.card-grid.theme--dark {
  background: #272727;
}
.card-grid > .v-card__text > .custom-divider {
  border: 2px solid!important;
  max-width: 75%;
}
</style>
